import { ApolloClient, gql, NormalizedCacheObject, useApolloClient, useQuery } from '@apollo/client';
import { AnyObject } from '../../../models/types';
import { MetricStatsMap, TimeRange } from '@amzn/search-services-cluster-insights-commons-lib/dist/common/interfaces';

export interface GetMetricsVars {
    entityType: string;
    entityValue: string;
    startTime: number;
    endTime: number;
    metrics: string; 
    period: number;
}

export interface GetMetricsData {
  getMetrics: any;
}

export const GET_METRICS = gql`
    query GetMetrics(
            $entityType: String,
            $entityValue: String,
            $startTime: Float,
            $endTime: Float,
            $metrics: JSON,
            $period: Int,
        ){
        getMetrics(
            entityType: $entityType,
            entityValue: $entityValue
            startTime: $startTime,
            endTime: $endTime,
            metrics: $metrics,
            period: $period
        )
    }
`;


export const useGetMetricsQuery = (vars: GetMetricsVars) => {
    return useQuery<AnyObject, GetMetricsVars>(GET_METRICS, {
        variables: { ...vars },
        errorPolicy: 'all'
    });
};

export async function fetchDomainMetrics(
  client: ApolloClient<NormalizedCacheObject> | ApolloClient<object>,
  domainIdent: string,
  metricStats: MetricStatsMap,
  range: TimeRange,
  period = 5
): Promise<any> {
  const metricDataQueries = Object.entries(metricStats).map(([metricName, stats]) => ({
    metric_name: metricName,
    stats: stats.map((s) => s.toUpperCase()),
  }));

  const { data } = await client.query<GetMetricsData, GetMetricsVars>({
    query: GET_METRICS,
    variables: {
      entityType: 'DOMAINIDENT',
      entityValue: domainIdent,
      startTime: range.startTime,
      endTime: range.endTime,
      metrics: JSON.stringify(metricDataQueries),
      period,
    },
    fetchPolicy: 'network-only',
  });

  return data.getMetrics;
}